import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Column from '@amzn/meridian/column';
import { SmediumLoader } from './SmediumLoader';
export const Loading = () => (_jsx(Column, { alignmentHorizontal: "center", alignmentVertical: "center", spacingInset: "400", height: "80vh", children: _jsx(SmediumLoader, {}) }));
